import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { UserDto } from '../../../user/dtos/user.dto';
import { PageStateService } from '../../services/page-state.service';
import { MatSidenavContent } from '@angular/material/sidenav';
import appInfo from '../../../../../package.json';
import { CountersService } from '../../services/counters.service';
import { CountersDto } from '../../dtos/counters.dto';
import { environment } from '../../../../environments/environment';
import { EnvironmentName } from '../../../../environments/EnvironmentName';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  version = appInfo.version;
  counters?: CountersDto;

  isTest = environment.name !== EnvironmentName.prod;

  private mobileQuery: MediaQueryList;
  private mobileQueryListener: () => void;

  @ViewChild('wrapper') wrapper: MatSidenavContent;

  constructor(
    private authService: AuthService,
    private media: MediaMatcher,
    private cd: ChangeDetectorRef,
    private pageStateService: PageStateService,
    private countersService: CountersService
  ) { }

  async ngOnInit() {
    this.mobileQuery = this.media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);

    this.counters = await this.countersService.get();
  }

  ngAfterViewInit() {
    this.pageStateService.scrollContainer = this.wrapper.getElementRef().nativeElement;
  }

  ngOnDestroy() {
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
  }

  getCounter(value?: number) {
    if (!value) {
      return '';
    }
    if (value > 100) {
      return '100+';
    }

    return value;
  }

  async logout() {
    await this.authService.logout();
  }

  get user(): UserDto | undefined {
    return this.authService.user;
  }

  get mobile(): boolean {
    return this.mobileQuery.matches;
  }

}
